import axios, { AxiosResponse } from 'axios';
import { SERVER_URL } from 'Constants';

export type FeatureName = "Mploi";

export type FeatureFlag = {
	id: string;
	created: Date;
	modified: Date;
	name: FeatureName;
	isEnabled: boolean;
}

export async function getFeatureFlags(): Promise<AxiosResponse<FeatureFlag[]>> {
	const url = `${SERVER_URL}/api/App/FeatureFlag`;
	return await axios.get<FeatureFlag[]>(url);
}

